export const ShoppingCartTabBar = 'tabbar'
export const ShoppingCartLabel = 'label'
export const ShoppingCartIcon = 'cart_icon'
export const ShoppingCart = 'shopping_cart'
export const ProductList = 'product_list'
export const ProductDetail = 'product_detail'
export const Server = 'server'
